// extracted by mini-css-extract-plugin
export default {"about":"About_about__2BNm1","content":"About_content__26AWS"};